import React from 'react';
import styled from 'styled-components/macro';
import Grid from '../Grid';
import { Heading, ActionText } from '../../typography';
import { SPACINGS } from '../../utils';
import { ActionType, LinkInternalType } from '../../types';
import { IconArrow } from '../../icons';

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 100%;

  & > *:not(:last-child) {
    margin-right: ${SPACINGS[4]};
  }
`;

type HeaderProps = {
  title: string | React.ReactNode;
  buttons?: React.ReactNode;
  back?: (ActionType | LinkInternalType) & { label: string };
  margin?: 'none';
  style?: React.CSSProperties;
};
function Header(props: HeaderProps) {
  const { title, back, buttons, margin, style = {} } = props;

  return (
    <Grid.Row
      style={{ marginBottom: margin === 'none' ? 0 : SPACINGS[6], ...style }}
    >
      <Grid.Col md={buttons ? 6 : 12} xs={12}>
        {back && (
          <ActionText
            size="sm"
            margin="none"
            {...back}
            iconLeft={<IconArrow direction="left" />}
          >
            {back.label}
          </ActionText>
        )}
        {typeof title === 'string' ? (
          <Heading style={back ? {} : { marginTop: SPACINGS[6] }} margin="none">
            {title}
          </Heading>
        ) : (
          title
        )}
      </Grid.Col>
      {buttons && (
        <Grid.Col md={6} xs={12}>
          <ButtonsWrapper>{buttons}</ButtonsWrapper>
        </Grid.Col>
      )}
    </Grid.Row>
  );
}

export default Header;
